/* eslint-disable no-unused-vars, max-len */
const { feWp } = window;
const { addAction } = feWp.hooks;

// Function to stop autoplay on the slider object
const stopAutoPlay = ( sliderObj, enabled = false ) => {
  if( enabled ) {
    sliderObj.autoplay.stop();
  }
};

const updateProgressBar = ( swiper ) => {
  const progressBarFill = swiper.el.querySelector( '.swiper-pagination-progressbar-fill' );
  const activeSlide = swiper.realIndex + 1;
  const progress = ( ( activeSlide / ( swiper.originalSlideCount ) ) ) * 100;
  if ( progressBarFill ) {
    progressBarFill.style.width = progress + '%';
  }
};

const updateDots = ( swiper ) => {
  const dots = swiper.el.querySelectorAll( '.swiper-pagination-bullet' );
  dots.forEach( dot => {
    dot.addEventListener( 'click', () => {
      stopAutoPlay( swiper );
    } );
  } );
};

// Add new video handler function
const handleSlideVideo = ( swiper ) => {
  const slides = swiper.slides;
  
  // Pause all videos first
  slides.forEach( slide => {
    const video = slide.querySelector( '.e-div--media-wrapper video' );
    if ( video ) {
      video.pause();
      video.currentTime = 0;
    }
  } );

  // Play video in active slide
  const activeSlide = slides[swiper.activeIndex];
  const activeVideo = activeSlide?.querySelector( '.e-div--media-wrapper video' );
  if ( activeVideo ) {
    activeVideo.play().catch( err => console.error( 'Error playing video:', err ) );
  }
};

addAction(
  'b3rg_slider_init',
  'b3rg/slider',
  ( settings, el, swiper ) => {
    swiper.params.lazyPreloadPrevNext = 2;
    const isInfinite = settings.loop;
    const isProgressbar = settings.pagination?.type;
    if ( isInfinite ) {
      swiper.params.supports4k = true;
      swiper.params.longSwipesRatio = 0;
      swiper.params.threshold = 0;
      swiper.params.touchRatio = 0.1;
      swiper.params.slideToClickedSlide = true;
      swiper.params.autoplay = {
        delay: settings?.autoplay?.delay || 3000,
      };
      if ( isProgressbar ) {
        swiper.params.pagination = {
          el: '.swiper-pagination',
          type: 'custom',
          renderCustom: function ( swiper, current, total ) {
            return '<div class="swiper-pagination-wrpr"><span class="swiper-pagination-progressbar-fill"></span></div><div class="swiper-fraction-custom">' +
              current +
              '/' + ( swiper.originalSlideCount ) + '</div>';
          },
          renderFraction: function () {
            return '';
          }
        };
        el.querySelector( '.swiper-pagination' ).classList.add( 'swiper-pagination-custom' );
        swiper.on( 'slideChange', function () {
          updateProgressBar( this );
        } );
        swiper.on( 'init', function () {
          // Update the progress bar on initialization
          updateProgressBar( this );
        } );
      }
      swiper.update();
    }

    swiper.on( 'afterInit', ( swiper )=> {
      updateDots( swiper );
    } );
    
    const arrows = swiper.el.querySelectorAll( '.e-sld__btn' );
    arrows.forEach( arrow => {
      arrow.addEventListener( 'click', () => {
        stopAutoPlay( swiper );
      } );
    } );
    swiper.on( 'click', function () {
      stopAutoPlay( swiper );
    } );
    swiper.on( 'touchStart', function () {
      stopAutoPlay( swiper );
    } );
    // Prevent additional swipes during the transition
    swiper.on( 'slideChangeTransitionStart', () => {
      swiper.allowTouchMove = false;
      swiper.hostEl.classList.add( 'swiper-slide-transition' );
    } );
    // Re-enable touch dragging after the transition
    swiper.on( 'slideChangeTransitionEnd', () => {
      swiper.allowTouchMove = true;
      swiper.hostEl.classList.remove( 'swiper-slide-transition' );
    } );

    // Initialize videos on load
    swiper.on( 'init', () => {
      handleSlideVideo( swiper );
    } );

    // Handle videos on slide change
    swiper.on( 'slideChange', () => {
      handleSlideVideo( swiper );
    } );
  },
  10,
  1,
);
